
import "./notfound.css";
import { Link } from "react-router-dom";
export default function NotFound(){
    return (
        <>
        <div className="section">
    <center>
    <h1 className="error">404</h1>
  <div className="page">Oops!!! The page you are looking for is not found</div>
  <Link className="back-home" to="/">Back to home</Link>
    </center>
</div>
</>
    );
}
